import { render } from "./AiReportsPage.vue?vue&type=template&id=b1ba43c0&scoped=true"
import script from "./AiReportsPage.vue?vue&type=script&lang=js"
export * from "./AiReportsPage.vue?vue&type=script&lang=js"

import "./AiReportsPage.vue?vue&type=style&index=0&id=b1ba43c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ba43c0"]])

export default __exports__